module.exports = __webpack_public_path__ + "img/jpm_icons3.94541054.svg";